package app.nestbridge.feature.children.service

import app.nestbridge.feature.children.api.model.ChildDto
import app.nestbridge.feature.children.api.model.ChildStatusDto
import app.nestbridge.feature.children.model.Child
import app.nestbridge.feature.children.model.ChildStatus

internal fun ChildDto.toDomain(): Child = Child(
    id = id,
    fullName = fullName,
    displayName = displayName,
    dateOfBirth = dateOfBirth,
    primaryLanguages = primaryLanguages,
    stewardUserIds = stewardUserIds,
    profilePictureUrl = profilePictureUrl,
    status = status.toDomain(),
    createdAt = createdAt,
    createdBy = createdBy,
    modifiedAt = modifiedAt,
    modifiedBy = modifiedBy,
)

internal fun Child.toDto(): ChildDto = ChildDto(
    id = id,
    fullName = fullName,
    displayName = displayName,
    dateOfBirth = dateOfBirth,
    primaryLanguages = primaryLanguages,
    stewardUserIds = stewardUserIds,
    profilePictureUrl = profilePictureUrl,
    status = status.toDto(),
    createdAt = createdAt,
    createdBy = createdBy,
    modifiedAt = modifiedAt,
    modifiedBy = modifiedBy,
)

internal fun ChildStatusDto.toDomain(): ChildStatus = when (this) {
    ChildStatusDto.ACTIVE -> ChildStatus.Active
    ChildStatusDto.SUSPENDED -> ChildStatus.Suspended
    ChildStatusDto.ARCHIVED -> ChildStatus.Archived
}

internal fun ChildStatus.toDto(): ChildStatusDto = when (this) {
    ChildStatus.Active -> ChildStatusDto.ACTIVE
    ChildStatus.Suspended -> ChildStatusDto.SUSPENDED
    ChildStatus.Archived -> ChildStatusDto.ARCHIVED
}
